import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Minibusonrentinpune() {



  const cardData =
  {
    keyword: 'Mini Bus On Rent in Pune ',
    heading: 'Sanavi Travels: Mini Bus On Rent in Pune',
    headingDescription: 'Sanavi Travels offers reliable Mini Bus On Rent in Pune, providing safe, comfortable, and hassle-free group travel solutions for families, corporate teams, tour groups, schools, colleges, and event organizers. Our fleet of 20, 25, 30, 32, 35, 40, 45, and 50 seater mini buses is ideal for local sightseeing, corporate outings, school excursions, wedding transport, and intercity travel, ensuring spacious seating, air-conditioned comfort, and ample luggage space. With experienced chauffeurs, flexible one-way and round-trip rental options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees a smooth and enjoyable journey. From doorstep pickup across Pune—including Hinjewadi, Wakad, Baner, Kothrud, Hadapsar, Pimpri-Chinchwad, and Pune Airport—to drop-off at local or outstation destinations, Sanavi Travels provides trusted Mini Bus On Rent in Pune for travelers seeking comfort, safety, and reliable group transportation.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show vividly brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage, valor, and architectural brilliance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum showcasing Gandhi’s personal artifacts, photographs, and historical documents. The palace’s sprawling gardens, Italian arches, and serene ambiance make it a peaceful retreat. The site also houses the samadhis of Kasturba Gandhi and Mahadev Desai, making it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations with music, decorations, and cultural events. The trust behind the temple is also known for extensive charitable work. Devotees find immense peace, blessings, and spiritual solace here. Dagdusheth Ganpati remains the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges, dotted with lush greenery. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature, attracting both historians and thrill-seekers."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi pavilion, and a serene sanctum. Despite being located in a busy urban area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase the mastery of early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat, offering peace, meditation, and a connection with the city’s ancient past."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. The collection includes traditional ornaments, musical instruments, household antiques, and sculptures. The recreated Mastani Mahal is a major attraction, depicting the lifestyle of historical India. The museum serves as a living archive of art, craftsmanship, and history, making it an invaluable destination for art lovers, students, and tourists seeking cultural insights."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point, attracting devotees, history enthusiasts, and nature lovers alike."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation, rejuvenation, and personal transformation. Osho Ashram is Pune’s international retreat for tranquility, blending spiritual learning with holistic wellness practices."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families, joggers, and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature, offering a serene sanctuary within Pune’s urban landscape. It is an ideal spot for relaxation, picnics, and reconnecting with nature."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during the monsoon season. Street vendors selling roasted corn, tea, and local snacks add to its charm. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends, sunset views, and family outings, offering both natural beauty and recreational opportunities."
  }
]
,




"services": [
    {
      "name": "Mini Bus On Rent in Pune",
      "description": "Mini Bus On Rent in Pune provides spacious and comfortable vehicles for group travel within Pune and surrounding areas. Ideal for family outings, corporate events, school trips, and sightseeing tours, these mini buses ensure safety, punctuality, and reliable service. Professional drivers manage routes efficiently, allowing passengers to relax and enjoy a stress-free travel experience with flexible booking options."
    },
    {
      "name": "Mini Bus Hire Pune",
      "description": "Mini Bus Hire Pune offers flexible rental services for short or long trips across Pune. Vehicles are well-maintained, equipped with ample seating, luggage space, and safety features. Experienced drivers ensure smooth travel, timely arrivals, and a convenient journey for families, friends, or corporate groups looking for comfortable group transport solutions."
    },
    {
      "name": "Mini Bus Rental Service Pune",
      "description": "Mini Bus Rental Service Pune specializes in providing reliable and spacious vehicles for group travel. Perfect for city tours, corporate outings, weddings, school trips, and long-distance travel, these vehicles emphasize comfort, safety, and punctuality. Flexible booking options and professional drivers make group transport hassle-free and enjoyable."
    },
    {
      "name": "AC Mini Bus Pune",
      "description": "AC Mini Bus Pune offers air-conditioned vehicles to ensure a comfortable and cool journey across Pune. Ideal for long trips, family outings, or corporate travel, these vehicles provide ample seating, luggage-friendly interiors, and a smooth ride. Professional chauffeurs handle traffic and routes efficiently, allowing passengers to relax and enjoy their journey."
    },
    {
      "name": "Luxury Mini Bus Pune",
      "description": "Luxury Mini Bus Pune provides premium vehicles with well-appointed interiors for elegant and comfortable group travel. Equipped with reclining seats, entertainment systems, and spacious luggage areas, these buses are ideal for VIP travel, corporate trips, or family outings. Professional drivers ensure punctual and safe journeys, delivering a stylish and hassle-free experience."
    },
    {
      "name": "Mini Bus for Wedding Pune",
      "description": "Mini Bus for Wedding Pune offers spacious and comfortable transport for wedding guests. Ideal for pre-wedding events, ceremonies, and group transfers, these vehicles provide ample seating, luggage space, and professional drivers to ensure a smooth and reliable travel experience for all attendees."
    },
    {
      "name": "Mini Bus for Corporate Pune",
      "description": "Mini Bus for Corporate Pune caters to office groups and business travelers requiring comfortable and punctual transport. Vehicles feature spacious seating, premium interiors, and amenities suitable for professional travel. Experienced drivers handle routes efficiently, ensuring reliable and stress-free corporate travel for meetings, conferences, and office outings."
    },
    {
      "name": "Mini Bus for Outstation Pune",
      "description": "Mini Bus for Outstation Pune provides reliable vehicles for long-distance trips outside Pune. Comfortable seating, luggage-friendly interiors, and professional drivers ensure a smooth and safe journey for families, friends, or corporate groups traveling to nearby cities or tourist destinations."
    },
    {
      "name": "Affordable Mini Bus Pune",
      "description": "Affordable Mini Bus Pune offers budget-friendly group transport without compromising on comfort or safety. Well-maintained vehicles, experienced drivers, and spacious interiors make these mini buses ideal for economical travel, school trips, family outings, or corporate events across Pune."
    },
    {
      "name": "Chauffeur Driven Mini Bus Pune",
      "description": "Chauffeur Driven Mini Bus Pune provides skilled drivers for a hassle-free travel experience. Passengers can relax while professional chauffeurs handle routes, traffic, and navigation. Spacious and comfortable vehicles accommodate families, friends, or corporate groups, ensuring safe, convenient, and enjoyable transport."
    },
    {
      "name": "Mini Bus for School Trip Pune",
      "description": "Mini Bus for School Trip Pune offers safe and reliable transport for students and teachers. Vehicles are well-maintained, spacious, and equipped with safety features, ensuring a comfortable journey for educational trips, excursions, or inter-school events. Experienced drivers prioritize safety and punctuality throughout the trip."
    },
    {
      "name": "Mini Bus Group Travel Pune",
      "description": "Mini Bus Group Travel Pune caters to large groups requiring comfortable and reliable transport. Ideal for corporate outings, family trips, sightseeing tours, or social events, these mini buses provide spacious seating, luggage-friendly interiors, and professional drivers for a smooth and enjoyable journey."
    },
    {
      "name": "Best Mini Bus in Pune",
      "description": "Best Mini Bus in Pune offers top-quality vehicles and professional service for group travel. Comfortable interiors, skilled drivers, and attention to passenger convenience ensure a superior travel experience. Perfect for families, corporate groups, and social outings, this service prioritizes safety, comfort, and reliability."
    },
    {
      "name": "Pune Mini Bus Booking",
      "description": "Pune Mini Bus Booking provides easy online and offline booking options for renting mini buses. Flexible scheduling, transparent pricing, and professional drivers make it convenient for group travel, city tours, corporate events, or family outings in and around Pune."
    },
    {
      "name": "Mini Bus for Family Tour Pune",
      "description": "Mini Bus for Family Tour Pune ensures a safe and comfortable journey for families exploring Pune or nearby destinations. Spacious seating, luggage-friendly interiors, and professional drivers make it ideal for multi-day trips, sightseeing tours, or weekend getaways, providing a relaxed and enjoyable travel experience."
    }
  ],
  "tableData": [
    ["Mini Bus On Rent in Pune", "Mini Bus Hire Pune"],
    ["Mini Bus Rental Service Pune", "AC Mini Bus Pune"],
    ["Luxury Mini Bus Pune", "Mini Bus for Wedding Pune"],
    ["Mini Bus for Corporate Pune", "Mini Bus for Outstation Pune"],
    ["Affordable Mini Bus Pune", "Chauffeur Driven Mini Bus Pune"],
    ["Mini Bus for School Trip Pune", "Mini Bus Group Travel Pune"],
    ["Best Mini Bus in Pune", "Pune Mini Bus Booking"],
    ["Mini Bus for Family Tour Pune", "—"]
  ]
,


"whychoose": [
  {
    "WhyChooseheading": "Mini Bus On Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable mini bus rental services in Pune, perfect for group trips, corporate events, school/college outings, and city tours."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Mini Buses",
    "WhyChoosedescription": "Travel in well-maintained, air-conditioned mini buses designed for comfort and convenience for group journeys in and around Pune."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Pune Routes",
    "WhyChoosedescription": "Our professional drivers are knowledgeable about Pune city and nearby routes, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear, upfront pricing for mini bus rentals, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and travel inquiries."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans",
    "WhyChoosedescription": "Choose from half-day, full-day, or customized mini bus rental plans to suit your group travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All mini buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for mini bus rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide mini bus on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers well-maintained and comfortable mini buses for group travel in Pune.'
  },
  {
    question: 'How can I book a mini bus in Pune with Sanavi Travels?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What seating capacities are available for mini buses?',
    answer: 'We offer mini buses with various seating capacities suitable for small and large groups.'
  },
  {
    question: 'Are drivers included in the mini bus rental?',
    answer: 'Yes, all mini bus rentals include experienced and professional drivers.'
  },
  {
    question: 'Is the mini bus rental service available 24x7?',
    answer: 'Yes, our mini bus rental service is available round the clock.'
  },
  {
    question: 'Are the vehicles sanitized before trips?',
    answer: 'Yes, all mini buses are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'Can I customize the mini bus rental plan?',
    answer: 'Absolutely. Sanavi Travels offers customized rental plans based on your requirements.'
  },
  {
    question: 'What payment options are available for mini bus bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Patil',
    feedback: 'Booked a mini bus from Sanavi Travels. Comfortable vehicle and professional driver made our Pune trip enjoyable.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Meera Joshi',
    feedback: 'Excellent service! Spacious mini bus, punctual pickup, and smooth journey in Pune.',
    rating: 5
  }
];
























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mini Bus On Rent in Pune - Sanavi Travels",
  "description": "Mini bus on rent in Pune by Sanavi Travels for corporate outings, family tours, school trips, weddings, and group travel. Choose AC and luxury mini buses for comfortable and affordable travel in and around Pune.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2765"
  }
};





  return (
    <div>

<Helmet>
  <title>
    Mini Bus On Rent in Pune Starting from ₹35 Per Km | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book mini bus on rent in Pune with Sanavi Travels. AC and luxury mini bus for weddings, corporate trips, school outings, family tours, and group travel at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Minibusonrentinpune;